export default "__VITE_ASSET__Cr8C8cdA__"